import {Component, Output, ViewChild, EventEmitter, ElementRef} from '@angular/core';
import {ModalDirective} from 'ng2-bootstrap/modal';
import {ToasterService} from 'angular2-toaster/angular2-toaster';
import {ClientsService} from "../../../models/clients/clients.service";
import {IClientModel} from "../../../models/clients/clients.model";
import {StaticDataService} from "../../../services/StaticData.service";
import {LeadsModel} from "../../../models/leads/leads.model";
import {UsersService} from "../../../models/users/users.service";
import {ValidationService} from "../../../services/validation.service";
import {phoneFormatter} from "../../../helpers/phone-format";
import { Router } from '@angular/router';

@Component({
    selector: 'lead-create-client',
    templateUrl: 'lead-create-client.template.html',
    exportAs: 'leadCreateClient'
})
export class LeadCreateClientComponent {
    phoneFormatter = phoneFormatter;
    public $newClientForm;

    public industries: Array<any>;
    public businessLength: Array<any>;
    public timeFrame: Array<any>;
    public purpose: Array<any>;
    public fundingSpecialist: Array<any>;

    private model: IClientModel = ClientsService.getEmptyModel();
    private leadData: LeadsModel;

    @ViewChild('leadCreateClientModal') public leadCreateClientModal: ModalDirective;
    @Output() onSaveClient: EventEmitter<any> = new EventEmitter<any>();


    // ===========================================================
    // Init
    // ===========================================================

    constructor(
                private toasterService: ToasterService,
                private clientsService: ClientsService,
                public usersService: UsersService,
                protected el: ElementRef,
                protected validationService: ValidationService,
                private router: Router
    ) {

    }

    ngOnInit() {
        this.loadUserFSList();

        this.businessLength = this.clientsService.getBusinessLength();
        this.timeFrame = this.clientsService.getTimeFrame();
        this.purpose = this.clientsService.getPurpose();
        this.industries = StaticDataService.getInstance().getData();
    }

    ngAfterViewInit() {
        this.$newClientForm = $('[name="new-client-form"]', this.el.nativeElement);
        this.validateForm();
    }

    // ===========================================================
    // Load Data
    // ===========================================================

    private loadUserFSList() {

        this.usersService.getFS()
            .subscribe(
                (res) => {
                    this.fundingSpecialist = res.data;
                },
                (error) => {
                    let errorData = JSON.parse(error._body);
                });
    }


    // ===========================================================
    // Actions
    // ===========================================================

    public hide() {
        this.leadCreateClientModal.hide();
    }

    public show(lead: LeadsModel) {

        this.model = ClientsService.getEmptyModel();
        this.$newClientForm.data('validator').resetForm();

        this.leadData = lead;

        this.model.client_name = this.leadData.contact;
        this.model.company_name = this.leadData.company_name;
        this.model.telephone = this.leadData.telephone;
        this.model.address = this.leadData.address;
        this.model.lead_id = this.leadData.id;

        this.leadCreateClientModal.show();
    }

    // ===========================================================
    // Functions
    // ===========================================================

    private validateForm() {
        this.$newClientForm
            .validate({
                rules: {
                    client_name: {
                        required: true,
                        maxlength: 200
                    },
                    company_name: {
                        required: true,
                        maxlength: 200
                    },
                    industry_id: {
                        number: true,
                    },
                    email: {
                        email: true,
                        required: true
                    },
                    business_age_id: {
                        number: true
                    },
                    avg_monthly_credit: {
                        min: 1,
                        number: true,
                        required: true
                    },
                    financing_required: {
                        min: 1,
                        number: true,
                        required: true
                    },
                    timeframe: {
                        number: true
                    },
                    purpose: {
                        number: true
                    },
                    closer_id: {
                        number: true,
                        required: true
                    },
                    notes: {
                        minlength: 1,
                        maxlength: 250
                    },
                },
                messages:{
                    industry_id: { number: 'Please select Industry'},
                    business_age_id: { number: 'Please select Length of Time in Business'},
                    timeframe: { number: 'Please select Timeframe'},
                    purpose: { number: 'Please select Purpose'},
                    closer_id: { number: 'Please select Funding Specialist'},
                },
                submitHandler: (form) => {

                    this.$newClientForm.find('input,button').prop("disabled", true);
                    this.clientsService.add(this.model)
                        .subscribe(
                            (data) => {
                                this.$newClientForm.find('input,button').prop("disabled", false);
                                this.$newClientForm[0].reset();
                                this.hide();

                                this.toasterService.pop('success', 'Success', 'Save new  client');

                                try {
                                    if (data.data.id) {
                                        var _a = document.createElement('a');
                                        _a.href = '/funding-specialist/new-leads';
                                        var _url: any = new URL(_a.href);
                                        _url.searchParams.set('q', String(data.data.id));
                                        this.router.navigateByUrl(_url.pathname + _url.search);
                                    } else {
                                        throw 'x';
                                    }
                                } catch (eee) {
                                    this.onSaveClient.emit();
                                }
                            },
                            (error) => {

                                this.$newClientForm.find('input,button').prop("disabled", false);
                                this.validationService.showError(error, form);
                            });

                    return false;

                }
            });
    }

}


// WEBPACK FOOTER //
// ./src/app/views/leads/create-client/lead-create-client.component.ts